/*接收图片格式*/
export const IMG_ACCEPT = "image/jpeg,image/png,image/tiff,image/gif";